'use client';

import { useState, useEffect } from 'react';

interface NavItem {
  label: string;
  href: string;
}

const navItems: NavItem[] = [
  { label: 'Practice Areas', href: '#practice-areas' },
  { label: 'Our Firm', href: '#our-firm' },
  { label: 'Attorneys', href: '#attorneys' },
  { label: 'Results', href: '#selected-matters' },
  { label: 'Reviews', href: '#client-reviews' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className="site-header"
      style={{
        position: 'fixed',
        background: scrolled ? 'rgba(21,18,15,0.97)' : 'transparent',
        transition: 'background 0.3s',
        borderBottom: scrolled ? '1px solid rgba(185,152,95,0.3)' : '1px solid rgba(255,255,255,0.2)',
      }}
    >
      <div className="site-container header-inner">
        {/* Brand */}
        <a href="/" className="brand">
          <span className="brand-mark">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round">
              <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
              <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
              <path d="M7 21h10" />
              <path d="M12 3v18" />
              <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
            </svg>
          </span>
          <span>
            <strong>Harrington &amp; Associates</strong>
            <em>LLP</em>
          </span>
        </a>

        {/* Mobile toggle */}
        <button
          className="mobile-menu"
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {menuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="4" x2="20" y1="12" y2="12" />
                <line x1="4" x2="20" y1="6" y2="6" />
                <line x1="4" x2="20" y1="18" y2="18" />
              </>
            )}
          </svg>
        </button>

        {/* Nav */}
        <nav className={`main-nav${menuOpen ? ' is-open' : ''}`} aria-label="Primary navigation">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>
              {item.label}
            </a>
          ))}
          <a className="header-cta" href="#contact" onClick={() => setMenuOpen(false)}>
            Free Consultation
          </a>
        </nav>
      </div>
    </header>
  );
}
